export default __webpack_public_path__ + "static/media/product-marketing.8d96e23f.webp";